import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../footer/Footer'; // Import Footer component

const Home = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            <header className="border-b p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto flex flex-wrap justify-between items-center">
                    <div className="text-2xl md:text-3xl font-bold flex items-center gap-2">
                        <h1>Prodyt</h1>
                    </div>
                    {/* Hamburger Menu Button */}
                    <button
                        className="block md:hidden text-white focus:outline-none"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                    </button>
                    {/* Navigation Menu */}
                    <nav
                        className={`${
                            menuOpen ? 'block' : 'hidden'
                        } absolute top-12 right-4 bg-blue-900 z-10 rounded-md md:static md:w-auto md:bg-transparent md:flex flex-col md:flex-row gap-4 md:gap-6`}
                    >
                        <Link to="/" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Home
                        </Link>
                        <Link to="/about" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            About Us
                        </Link>
                        <Link to="/privacy-policy" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Privacy Policy
                        </Link>
                        <Link to="/help-center" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Help Center
                        </Link>
                        <Link to="/terms-of-service" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Terms of Service
                        </Link>
                        <Link to="/delete-account" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Delete Account
                        </Link>
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 p-4 md:p-6">
                {/* Welcome Section */}
                <section className="mb-12 text-center">
                    <h2 className="text-2xl md:text-4xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        Welcome to Prodyt
                    </h2>
                    <p className="text-gray-600 text-base md:text-lg">
                        The next-generation mobile app that revolutionizes warranty management for both customers and companies.
                    </p>
                </section>

                {/* About Us Section */}
                <section className="mb-12 bg-blue-50 border-l-4 border-blue-500 p-4 md:p-6 rounded shadow-lg">
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-blue-600">About Us</h2>
                    <p className="text-gray-700 mb-4 text-sm md:text-base">
                        We've designed a seamless, intuitive platform to help users effortlessly register products, track warranties, and manage complaints all in one place.
                    </p>
                    <Link to="/about" className="text-blue-600 hover:underline transition duration-300">Learn more about us →</Link>
                </section>

                {/* Privacy Policy Section */}
                <section className="mb-12 bg-yellow-50 border-l-4 border-yellow-500 p-4 md:p-6 rounded shadow-lg">
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-yellow-600">Privacy Policy</h2>
                    <p className="text-gray-700 mb-4 text-sm md:text-base">
                        At Prodyt, we're committed to protecting your personal information and being transparent about how we use it.
                    </p>
                    <Link to="/privacy-policy" className="text-yellow-600 hover:underline transition duration-300">Read our privacy policy →</Link>
                </section>

                {/* Help Center Section */}
                <section className="mb-12 bg-green-50 border-l-4 border-green-500 p-4 md:p-6 rounded shadow-lg">
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-green-600">Help Center</h2>
                    <p className="text-gray-700 mb-4 text-sm md:text-base">
                        Find answers to common questions or contact our support team directly.
                    </p>
                    <Link to="/help-center" className="text-green-600 hover:underline transition duration-300">Visit our Help Center →</Link>
                </section>

                {/* Features Section */}
                <section className="mb-12 bg-gray-50 border-l-4 border-gray-500 p-4 md:p-6 rounded shadow-lg">
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-600">Key Features</h2>
                    <ul className="list-disc pl-6 text-gray-700 space-y-2 text-sm md:text-base">
                        <li>Product Registration: Quickly register your products by scanning QR codes or entering details manually.</li>
                        <li>Warranty Tracking: Stay on top of your product's warranty status with real-time updates.</li>
                        <li>Warranty Support: Access direct online warranty support for registered products.</li>
                        <li>Complaint Management: Effortlessly raise and track complaints with full visibility.</li>
                    </ul>
                </section>

                {/* Terms of Service Section */}
                <section className="mb-12 bg-purple-50 border-l-4 border-purple-500 p-4 md:p-6 rounded shadow-lg">
                    <h2 className="text-xl md:text-2xl font-bold mb-4 text-purple-600">Terms of Service</h2>
                    <p className="text-gray-700 mb-4 text-sm md:text-base">
                        By using Prodyt, you agree to our terms and conditions. Learn about your responsibilities, our limitations, and how we protect your data.
                    </p>
                    <Link to="/terms-of-service" className="text-purple-600 hover:underline transition duration-300">Read our Terms of Service →</Link>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Home;